import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../staff/StaffSideMenu";
import API_URL from "../../api/API";
import { useStaffAuthContext } from "../staff/useStaffAuthContext";
import { useNavigate, useParams } from "react-router-dom";

export const AdminLoadvelocityTrainingDataEdit = () => {
  const { staff } = useStaffAuthContext();
  const navigate = useNavigate();
  const { set_id } = useParams(); // Get template_id & set_id from URL

  const [setData, setSetData] = useState(null);
  const [reps, setReps] = useState("");
  const [distance, setDistance] = useState("");
  const [rest, setRest] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const fetchSetData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`${API_URL.GET_LOADVELOCITY_TRAINING_TEMPLATE_SET}${set_id}`, {
          headers: { Authorization: `Bearer ${staff.token}` },
        });
        const data = await response.json();

        if (!response.ok) throw new Error(data.message || "Failed to load set data");

        setSetData(data);
        setReps(data.reps);
        setDistance(data.distance);
        setRest(data.rest);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSetData();
  }, [set_id]);

  const saveSetData = async () => {
    setSuccessMessage("");
    try {
      const response = await fetch(`${API_URL.EDIT_LOADVELOCITY_TRAINING_TEMPLATE_SET}${set_id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff.token}`,
        },
        body: JSON.stringify({ reps, distance, rest }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Failed to update set data");

      setSuccessMessage("Set data updated successfully!");
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="flex h-screen">
      <StaffSideMenu />
      <div className="flex-1 p-6 bg-gray-100 pt-16 flex flex-col relative">
        <button
          onClick={() => navigate(-1)}
          className="absolute top-4 right-4 bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
        >
          Go Back
        </button>

        <div className="w-full max-w-lg mx-auto bg-white p-6 rounded shadow-md">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Edit Training Data</h2>

          {isLoading ? (
            <div className="text-center text-gray-600">Loading set data...</div>
          ) : error ? (
            <div className="text-red-500 text-center">{error}</div>
          ) : (
            <>
              {successMessage && (
                <div className="bg-green-100 text-green-700 p-2 mb-2 text-center rounded">{successMessage}</div>
              )}

              <label className="block mb-2">Reps</label>
              <input
                type="text"
                className="w-full border rounded p-2 mb-3"
                value={reps}
                onChange={(e) => setReps(e.target.value)}
              />

              <label className="block mb-2">Distance (m)</label>
              <input
                type="text"
                className="w-full border rounded p-2 mb-3"
                value={distance}
                onChange={(e) => setDistance(e.target.value)}
              />

              <label className="block mb-2">Rest</label>
              <textarea
                className="w-full border rounded p-2 mb-3"
                value={rest}
                onChange={(e) => setRest(e.target.value)}
              />

              <div className="flex justify-center">
                <button onClick={saveSetData} className="bg-blue-500 text-white py-2 px-6 rounded hover:bg-blue-600">
                  Save
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
